/* istanbul ignore file */
import React from 'react';
import RelationInput from '../RelationInput';
import ChildRelationInput from './ChildRelationInput';
import { DefaultInputPropTypes } from 'framework/form';

const ChildInput = (props: DefaultInputPropTypes<any>) => {
  return <RelationInput relationInput={ChildRelationInput} {...props} />;
};

export default ChildInput;
